export const marketing: Record<string, string> = {
  // Marketing/UA overview
  'mk.summary': 'Tổng',
  'mk.revCostByCountry': 'Rev & Cost theo quốc gia',
  // Filter bar
  'filter.range': 'Khoảng',
  'filter.partner': 'Đối tác',
  'filter.country': 'Quốc gia',
  'filter.status': 'Trạng thái',
  'filter.platform': 'Nền tảng',
  'filter.statusActive': 'Active',
  'filter.statusInactive': 'Inactive',
  'filter.searchPlaceholder': 'Tìm kiếm…',
  'filter.all': 'Tất cả',
  'filter.toggle': 'Bộ lọc',
  'filter.clearFilters': 'Xoá lọc',
  // UA Bot Console
  'ubc.forum': 'Diễn đàn',
  'ubc.interaction': 'Tương tác',
  'ubc.col.time': 'Thời gian',
  'ubc.col.action': 'Hành động',
  // Ads Builder
  'ads.campaign': 'Chiến dịch',
  // Marketing Report
  'mreport.owner': 'Người phụ trách UA',
  'mreport.ownerMonet': 'Người phụ trách Monet',
  'mreport.ownerDev': 'Dev sở hữu',
  'mreport.product': 'Sản phẩm',
  'mreport.col.iap': 'IAP',
  'mreport.kpiRevenue': 'Doanh thu',
  'mreport.kpiAdCost': 'Chi phí',
  'mreport.kpiIap': 'IAP',
  'mreport.iapEstimateNote': 'IAP ước tính từ báo cáo sales — cửa hàng (Google Play/App Store) chưa chốt tháng này. Sai lệch khoảng 1%. Số sẽ tự thay bằng số thật khi earnings về.',
  'mreport.kpiProfit': 'Lợi nhuận',
  'mreport.kpiRoas': 'ROAS',
  // UA performance (uat)
  'uat.trend': 'Xu hướng',
  'uat.day': 'Ngày',
  'uat.month': 'Tháng',
  'uat.year': 'Năm',
  'uat.from': 'Từ',
  'uat.to': 'Đến',
  // Date range picker
  'drange.today': 'Hôm nay',
  'drange.yesterday': 'Hôm qua',
  'drange.last3': '3 ngày qua',
  'drange.last7': '7 ngày qua',
  'drange.last14': '14 ngày qua',
  'drange.last30': '30 ngày qua',
  'drange.thisMonth': 'Tháng này',
  'drange.lastMonth': 'Tháng trước',
  'drange.custom': 'Tùy chọn',
  'drange.apply': 'Áp dụng',
  'uat.vsPrev': 'so với kỳ trước',
  'uat.tabOverview': 'Tổng quan',
  'uat.tabReport': 'Báo cáo',
  'uat.tabSummary': 'Tổng hợp',
  'uat.profitShare': 'Tỷ trọng lợi nhuận',
  'uat.topProducts': 'Sản phẩm lợi nhuận cao nhất',
  'uat.topLoss': 'Sản phẩm lỗ nhiều nhất',
  'uat.colTotalRev': 'Tổng DT',
  'uat.rankingProfit': 'Xếp hạng lợi nhuận',
  'uat.rankApp': 'Theo App',
  'uat.rankUa': 'Theo UA',
  'uat.rankLoss': 'Theo Lỗ',
  'uat.others': 'Khác',
  'uat.tabApp': 'App',
  'uat.perPage': 'trang',
  'uat.perfSummary': 'Tổng hợp hiệu suất',
  'uat.metric': 'Chỉ số',
  'uat.pickApp': 'Chọn một app từ danh sách để xem chi tiết',
  'uat.ggCost': 'Google',
  'uat.fbCost': 'Facebook',
  'uat.mtgCost': 'MTG',
  'uat.appleCost': 'Apple',
  'uat.totalCost': 'Tổng chi phí',
  'uat.chart': 'Biểu đồ',
  'uat.costBy': 'Chi phí theo',
  'uat.country': 'Quốc gia',
  'uat.campaign': 'Chiến dịch',
  'uat.convValue': 'Giá trị chuyển đổi',
  'uat.grandTotal': 'Tổng cộng',
  'uat.type': 'Loại',
  'uat.summaryCol': 'Tổng',
  'uat.active': 'đang chạy',
  'uat.product': 'Sản phẩm',

  // Bảng xếp hạng UA (chỉ admin)
  'uat.tabLeaderboard': 'Bảng xếp hạng',
  'lb.board1': 'Bảng xếp hạng UA theo lợi nhuận tích luỹ từ đầu kỳ đến từng tháng',
  // "dẫn đầu/đứng cuối tích luỹ" chứ không phải "đứng nhất": xếp hạng theo tổng luỹ tiến từ đầu kỳ,
  // nên một tháng dẫn đầu không có nghĩa là tháng đó lãi nhiều nhất.
  'lb.board2': 'Top 5 UA nhiều tháng dẫn đầu lợi nhuận tích luỹ',
  'lb.board3': 'Top 5 UA nhiều tháng đứng cuối lợi nhuận tích luỹ',
  // Đặt tên theo nội dung, không theo vị trí: hai bảng theo kỳ nằm chen vào giữa dãy board1..3.
  'lb.boardBestPeriod': 'Top 5 UA nhiều tháng dẫn đầu tích luỹ trong kỳ hiện tại',
  'lb.boardWorstPeriod': 'Top 5 UA nhiều tháng đứng cuối tích luỹ trong kỳ hiện tại',
  // Bảng cuối trang: cùng tháng, cùng người như bảng 1, nhưng cộng dồn từ tháng 1 (không reset theo kỳ).
  'lb.board6': 'Bảng xếp hạng UA theo lợi nhuận tích luỹ cộng dồn theo tháng trong năm',
  'lb.excludesLeavers': 'Có lợi nhuận trong kỳ thuộc app mà chủ không phải UA, nên thứ hạng này không phủ hết',
  'lb.top': 'Top',
  // Đếm SỐ THÁNG giữ thứ hạng đó trên bảng tích luỹ, không phải số lần thắng riêng từng tháng.
  // "Số lần nhất" khiến người đọc hiểu là thắng 4 tháng riêng lẻ — sai kể từ khi chuyển sang tích luỹ.
  'lb.timesFirst': 'Số tháng dẫn đầu',
  'lb.timesSecond': 'Số tháng hạng nhì',
  'lb.timesThird': 'Số tháng hạng ba',
  'lb.timesLast': 'Số tháng cuối bảng',
  'lb.timesSecondLast': 'Số tháng áp chót',
  // Đứng trước con số, ghép trong component: hệ i18n không nội suy tham số.
  'lb.scopeYear': 'hiệu suất năm',
  'lb.scopeRange': 'hiệu suất',
  'lb.ua': 'UA',
  'lb.from': 'Từ',
  'lb.to': 'Đến',
  'lb.empty': 'Không có gì để xếp hạng trong khoảng này.',
  'lb.pending': 'Nhấn Enter để áp dụng.',
};
